var _rect, _circle, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 48,
    height: 48,
    rx: 24,
    fill: "currentColor",
    fillOpacity: 0.05
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6667,
    cy: 24,
    r: 17,
    stroke: "currentColor",
    strokeOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6667,
    y: 12,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_27_2279)",
    fillOpacity: 0.07
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1667,
    y: 12.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "currentColor",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5647 20.977L28.0647 19.477C28.0125 19.4246 27.9504 19.383 27.882 19.3546C27.8136 19.3262 27.7403 19.3116 27.6663 19.3116C27.5923 19.3116 27.519 19.3262 27.4506 19.3546C27.3822 19.383 27.3201 19.4246 27.2679 19.477L25.7679 20.977C25.6622 21.0827 25.6028 21.226 25.6028 21.3755C25.6028 21.5249 25.6622 21.6682 25.7679 21.7739C25.8735 21.8796 26.0169 21.9389 26.1663 21.9389C26.3157 21.9389 26.4591 21.8796 26.5647 21.7739L27.1043 21.2344V23.3906L24.6668 25.8281L22.2293 23.3906V21.2344L22.7688 21.7744C22.8745 21.88 23.0178 21.9394 23.1672 21.9394C23.3167 21.9394 23.46 21.88 23.5657 21.7744C23.6713 21.6687 23.7307 21.5254 23.7307 21.3759C23.7307 21.2265 23.6713 21.0832 23.5657 20.9775L22.0657 19.4775C22.0134 19.4251 21.9513 19.3835 21.8829 19.3551C21.8146 19.3267 21.7413 19.3121 21.6672 19.3121C21.5932 19.3121 21.5199 19.3267 21.4515 19.3551C21.3832 19.3835 21.3211 19.4251 21.2688 19.4775L19.7688 20.9775C19.6631 21.0832 19.6038 21.2265 19.6038 21.3759C19.6038 21.5254 19.6631 21.6687 19.7688 21.7744C19.8745 21.88 20.0178 21.9394 20.1672 21.9394C20.3167 21.9394 20.46 21.88 20.5657 21.7744L21.1043 21.2344V23.625C21.1042 23.6989 21.1187 23.7721 21.1469 23.8404C21.1752 23.9086 21.2166 23.9707 21.2688 24.023L24.1043 26.8594V28.875C24.1043 29.0242 24.1635 29.1673 24.269 29.2727C24.3745 29.3782 24.5176 29.4375 24.6668 29.4375C24.816 29.4375 24.959 29.3782 25.0645 29.2727C25.17 29.1673 25.2293 29.0242 25.2293 28.875V26.8594L28.0647 24.0244C28.1171 23.9719 28.1586 23.9096 28.1869 23.8411C28.2151 23.7726 28.2295 23.6991 28.2293 23.625V21.2344L28.7688 21.7744C28.8211 21.8267 28.8832 21.8682 28.9516 21.8965C29.02 21.9248 29.0932 21.9394 29.1672 21.9394C29.2412 21.9394 29.3145 21.9248 29.3829 21.8965C29.4512 21.8682 29.5133 21.8267 29.5657 21.7744C29.618 21.7221 29.6595 21.6599 29.6878 21.5916C29.7161 21.5232 29.7307 21.4499 29.7307 21.3759C29.7307 21.3019 29.7161 21.2287 29.6878 21.1603C29.6595 21.0919 29.618 21.0298 29.5657 20.9775L29.5647 20.977Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.785 21.0208C36.0461 20.9509 36.202 20.6821 36.1215 20.424C35.3505 17.954 33.8012 15.7989 31.7054 14.2812C31.4865 14.1226 31.182 14.1848 31.0325 14.41C30.883 14.6352 30.9452 14.9381 31.1635 15.0974C33.0612 16.4822 34.467 18.4378 35.1751 20.6777C35.2566 20.9354 35.5239 21.0908 35.785 21.0208Z",
    fill: "url(#paint1_linear_27_2279)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5485 26.9792C13.2874 27.0491 13.1315 27.3179 13.212 27.576C13.983 30.046 15.5323 32.2011 17.6281 33.7189C17.847 33.8774 18.1515 33.8152 18.301 33.59C18.4505 33.3648 18.3883 33.0619 18.17 32.9026C16.2723 31.5178 14.8665 29.5622 14.1584 27.3223C14.0769 27.0646 13.8096 26.9092 13.5485 26.9792Z",
    fill: "url(#paint2_linear_27_2279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_2279",
    x1: 24.6667,
    y1: 36,
    x2: 24.6667,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC5520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5520",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_2279",
    x1: 30.9359,
    y1: 14.5556,
    x2: 35.7748,
    y2: 21.0236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#404556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27_2279",
    x1: 18.3976,
    y1: 33.4444,
    x2: 13.5587,
    y2: 26.9764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#404556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343849"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondIcon);
export default __webpack_public_path__ + "static/media/second-icon.a15ff53aebffea751fd06e1bef5bc9b5.svg";
export { ForwardRef as ReactComponent };